import { useMemo } from 'react';

import type {
  InputMaybe,
  Leads_Bool_Exp,
} from '@graphql/__generated__/graphql';
import {
  LeadsFiltersContext,
  type LeadsFiltersContextType,
} from '@modules/leads/components/context/leadsFiltersContext';
import {
  extractSelectedAgentsWhere,
  extractSelectedStagesWhere,
} from '@modules/leads/utils/extractFilters';

export const LeadsFiltersProvider = ({
  children,
  where,
}: {
  where: InputMaybe<Leads_Bool_Exp> | undefined;
  children: React.ReactNode;
}) => {
  const contextValue = useMemo<LeadsFiltersContextType>(() => {
    const selectedAgentsIds = extractSelectedAgentsWhere(where);
    const selectedStagesIds = extractSelectedStagesWhere(where);
    return {
      agentIds: selectedAgentsIds ?? [],
      stageIds: selectedStagesIds ?? [],
    };
  }, [where]);

  return (
    <LeadsFiltersContext.Provider value={contextValue}>
      {children}
    </LeadsFiltersContext.Provider>
  );
};
